// GALLERY PICTURE ELEMENT 

export const galleryPictureElement = (pictureSourceMax, pictureSourceMob) =>`
<picture>
    <source srcset="${pictureSourceMax} 4x, 
			${pictureSourceMob}" media="(max-width: 630px)">
    <source srcset="${pictureSourceMax} 4x, 
			${pictureSourceMax}" media="(min-width: 631px)">
    
    <img src="${pictureSourceMax}" alt="" loading="lazy">
</picture>`;
